import { toast } from 'react-toastify';
import {
   useCreateRoleMutation,
   useGetModuleListQuery,
   useGetPermissionListQuery,
} from '../../Redux/Service/RoleApi';
import { RolePermissionForm } from './Form';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

export default function AddRole() {
   const {
      data: permissionsList,
      isLoading: isPermissionsLoading,
      isError: isPermissionsError,
      error: permissionsError,
   } = useGetPermissionListQuery();
   const {
      data: modulesList,
      isLoading: isModulesLoading,
      isError: isModulesError,
      error: modulesError,
   } = useGetModuleListQuery();
   const [createRole] = useCreateRoleMutation();
   const navigate = useNavigate();

   const validationSchema = Yup.object().shape({
      roleName: Yup.string()
         .required('Role name is required')
         .min(3, 'Role name must be at least 3 characters')
         .max(50, 'Role name must be at most 50 characters'),

      permissionIds: Yup.array().of(Yup.number().required()).optional(),

      modules: Yup.array()
         .of(
            Yup.object().shape({
               moduleId: Yup.number().required('Module is required'),

               permissionIds: Yup.array()
                  .of(Yup.number().required())
                  .min(1, 'At least one permission is required for modules')
                  .required('At least one permission is required for modules'),
            }),
         )
         .min(1, 'At least one module is required')
         .optional(),
   });
   const handleSubmit = async (values, formikProps) => {
      try {
         await createRole(values).unwrap();

         toast.success('Role added successfully');
         navigate('/role-permissions');
      } catch (err) {
         console.log(err);

         toast.error(err?.data?.message || 'Failed to add role');
      } finally {
         formikProps.setSubmitting(false);
      }
   };

   const modulePermissions = modulesList?.response?.data?.map((module) => {
      // if (module.name === 'dashboard')
      //    return {
      //       moduleId: module.id,
      //       moduleName: module.name,
      //       permissions: permissionsList?.response?.data.filter((per) => per.name === 'read'),
      //    };

      return {
         moduleId: module.id,
         moduleName: module.name,
         permissions: permissionsList?.response?.data,
      };
   });
   return (
      <RolePermissionForm
         initialValues={{
            roleName: '',
            modules: [],
         }}
         handleSubmit={handleSubmit}
         validationSchema={validationSchema}
         showData={modulePermissions}
         isEdit={false}
      />
   );
}
